export const PHYSICAL_LOCATION_SORT_FIELDS = ['createdAt', 'name'] as const;

export const PHYSICAL_LOCATION_SORT_ORDERS = ['asc', 'desc'] as const;
